import { render, staticRenderFns } from "./saas_apply_detail.vue?vue&type=template&id=85c8777a&scoped=true"
import script from "./saas_apply_detail.vue?vue&type=script&lang=js"
export * from "./saas_apply_detail.vue?vue&type=script&lang=js"
import style0 from "./saas_apply_detail.vue?vue&type=style&index=0&id=85c8777a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c8777a",
  null
  
)

export default component.exports